import React, { useState, useEffect } from 'react';
import { useProjectTypes_Uploadpage } from './hooks';
//import { toast } from 'react-toastify'
import { Autocomplete, TextField } from '@mui/material';
import { sortDropdownOptions } from '../utils';

function FilterProjectType({
	setProjectType,
	ProjectType,
	setProjectTypeId,
	ProjectTypeId,
}) {
	const [options, setoptions] = useState([]);
	const project_type_hook = useProjectTypes_Uploadpage();
	const [Focus, setFocus] = useState(false);
	const [inputValue, setInputValue] = useState('');
	const [open, setOpen] = useState(false);
	const [firstTime, setfirstTime] = useState(true);

	useEffect(() => {
		if (project_type_hook.hook.data) {
			setfirstTime(false);
			setoptions(sortDropdownOptions(project_type_hook.hook.data.data.map((itm) => itm.name)));
		}
	}, [project_type_hook.hook.data, project_type_hook.hook.isSuccess]);

	useEffect(() => {
		project_type_hook.setArgs((args) => {
			return {
				...args,
				search: inputValue,
			};
		});
	}, [inputValue]);

	//const [ProjectTypeId, setProjectTypeId] = useState('')

	function changeProjectType(val) {
		//console.log(val);
		setProjectType(val);
		let obj = project_type_hook.hook.data.data.find((o) => o.name === val);
		//console.log(obj);
		if (obj) {
			setProjectTypeId(obj._id);
		}
		else{
			setProjectTypeId(null)
			setProjectType(null)
		}
	}

	let stop = false;

	return (
		<>
			<div>
				<div className="flex gap-3">
					<div className="grow">
						<div className="lightT">
							{firstTime && project_type_hook.hook.isPending ? (
								<p className="px-4 py-2 border border-1 border-slate-300 rounded-md">
									Project Type{' '}
									<span className="text-sm text-slate-400 ps-4 inline-block">
										Loading...
									</span>
								</p>
							) : (
								<Autocomplete
									disablePortal
									isOptionEqualToValue={(option, value) =>
										option === value || value === '' || value == null
									}
									id="combo-box-demo"
									filterOptions={(x) => x}
									options={options}
									value={ProjectType}
									open={open}
									onOpen={() => {
										setOpen(true);
									}}
									onClose={() => {
										setOpen(false);
									}}
									renderInput={(params) => (
										<TextField {...params} label="Project Type *" />
									)}
									onChange={(event, value) => changeProjectType(value)}
									onInputChange={(event, newInputValue) => {
										setInputValue(newInputValue);
									}}
									onFocus={() => setFocus(true)}
									onBlur={() => setFocus(false)}
									renderOption={(props, option) => {
										if (stop) return;
										if (project_type_hook.hook.isPending) {
											stop = true;
											return (
												<p key={'loading_project_type'} className="ml-2">
													Loading...
												</p>
											);
										}

										return (
											<li key={option} {...props}>
												{option}
											</li>
										);
									}}
								/>
							)}
							{ProjectType == null && Focus && (
								<small className="text-red-600 ">
									Project type is required
								</small>
							)}
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default FilterProjectType;
